<template>
  <div
    class="select-file-computer bg-lightest-gray d-flex align-items-center justify-content-center border border-1 rounded rounded-4 border-grey-40 p-50 position-relative"
  >
    <Spinner
      v-show="isLoading"
      :speed="1"
      size="huge"
      message="Loading..."
      class="position-absolute inner-Loader"
    />
    <div class="mage-icon text-center">
      <img src="../../assets/images/image-icon.png" >
      <p class="mt-16 fs-14 text-medium-gray mb-0">
        You can drag and drop file to upload
      </p>
      <label
        for="vfile-upload"
        class="custom-file-upload lf-btn mt-16 py-7 text-dark-gray fs-14 bg-transparent bm-bordered-btn browse-btn border-1 border border-dark-gray file-upload-btn position-relative"
      >Browse file
      </label>
      <div
        v-if="showExtensionError"
        class="mt-5 pt-5 fs-15 text-danger fw-bold text-center d-block">Please only upload .mp3 files</div>
      <div
        v-if="uploadError"
        class="mt-5 pt-5 fs-15 text-danger fw-bold text-center d-block">File cannot be uploaded</div>
      <input
        id="vfile-upload"
        type="file"
        class=""
        accept=".mp3"
        @change="audioUploaded"
      >
    </div>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import axios from 'axios';

export default {
  name:       'AudioFileSelect',
  components: {
    Spinner,
  },
  data() {
    return {
      isLoading:          false,
      showExtensionError: false,
      modalHidden:        true,
      uploadError:        false,
    };
  },
  mounted() {
    this.modalHidden = false;
    EventBus.$on('abortVideoUpload', this.abortAudioFileUpload);
  },
  methods: {
    async audioUploaded(e) {
      const self              = this;
      this.isLoading          = true;
      this.showExtensionError = false;
      this.uploadError        = false;
      this.modalHidden        = false;
      const file              = e.target.files[0];
      const extension         = file.name.split('.').pop();
      if (extension !== 'mp3') {
        console.log('wrong extension');
        this.isLoading = false;
        alert('Invalid File! (Allowed formats: mp3)');
        return;
      }
      if ((file.size / 1024 / 1024) > 50) {
        this.isLoading = false;
        alert('Audio file size can not be more than 50MB');
        return;
      }
      if (file) {
        const objectURL       = URL.createObjectURL(file);
        const audioPlayer     = document.createElement('audio');
        audioPlayer.src       = objectURL;
        let durationInSeconds = null;
        audioPlayer.addEventListener('loadedmetadata', () => {
          durationInSeconds = audioPlayer.duration;
          console.log('durationInSeconds ', durationInSeconds);

          const audioObj = {
            Name:         file.name,
            thumbnail:    'https://samples-files.com/wp-content/uploads/2023/03/sample-mp3-file.png',
            duration:     durationInSeconds,
            mimeType:     'audio/mp3',
            audioUrl:     objectURL,
            startTime:    0,
            endTime:      durationInSeconds,
            fadeIn:       0,
            fadeOut:      durationInSeconds,
            trimDuration: durationInSeconds,
          };
          self.handleAudioUpload(file, audioObj);
        });

        audioPlayer.remove();
      }
    },
    isSubdomain(url) {
      url         = `https://${url}.com`;
      const regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);
      return !!url.match(regex); // make sure it returns boolean
    },
    async handleAudioUpload(fileToUpload, audioObj) {
      const reqFormData        = new FormData();
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '21d29854-fb88-45e6-9a12-b1f4e6c67d45';
      reqFormData.append('audio', fileToUpload);
      reqFormData.append('file', fileToUpload);
      const headers = {
        'Content-Type': 'text/plain',
      };
      const url     = (this.isSubdomain(this.$store.getters.getBMCInstance)) ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;

      const serverURL = `https://${url}.com/WebServices/UploadAudios.ashx?userId=${userId}`;

      await axios.post(serverURL, reqFormData, { headers })
        .then(async (res) => {
          let url = res.data;
          if (url && url != '') {
            url               = url.substring(0, url.indexOf('#'));
            audioObj.audioUrl = url;
            EventBus.$emit(ApplicationEventTypes.Audio.ADD_NEW_AUDIO, audioObj);
          }
          EventBus.$emit('toggleAudioLeftSectionAccordion', true);
          EventBus.$emit('selectAudioLayerFromLeftSection', true);
          this.$store.commit('setDisplayAddAudioModal', false);
        })
        .catch((e) => {
          throw new Error(e.message);
        });
    },

    abortAudioFileUpload() {
      this.modalHidden = true;
    },
  },
};
</script>

<style scoped>
#vfile-upload {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  opacity: 0;
}
.inner-Loader {
  height: 100%;
  width: calc(100% - 0px);
  background: rgb(255, 255, 255);
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 56;
}
</style>
